import { httpClient } from '@internal/api/system';
import { mutationEndpoint } from '@internal/api/system/endpoints';
import { ApplicationStage } from '@internal/types/profile';

const markResumeConfirmed = mutationEndpoint({
  actionName: 'markResumeConfirmed',
  mutationKey: ['mark-resume-confirmed'],
  mutationFn: ({ apiKey }: { apiKey: string }) =>
    httpClient.auto<boolean>({
      url: '/api/application/stage',
      method: 'POST',
      data: { applicationStage: ApplicationStage.ResumeConfirmed },
      headers: {
        'auth-key': apiKey,
      },
    }),
  onSuccess: queryClient => {
    queryClient.invalidateQueries({ queryKey: ['profile'] });
    queryClient.invalidateQueries({ queryKey: ['application-state'] });
  },
});

export { markResumeConfirmed };
